import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KeywordService } from '@services/keyword.service';

@Component({
  selector: 'app-keyword',
  templateUrl: './keyword.component.html',
  styleUrls: ['./keyword.component.css']
})
export class KeywordComponent implements OnInit {

  keyword:any;
  id:any;
  constructor(private languageService:KeywordService,private route:ActivatedRoute) {
    
      
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
          this.getLangs(this.id);
  }


  getLangs(id:any){
     this.languageService.get(id).subscribe(res=>{
      this.keyword=res;
      console.log(res)
      
     })
  }



  getQuestionType(type:number){
      if(type==1){
        return "Kelime öğrenilen dil şıklar ana dil";

      }
      else if(type==2){
        return "Kelime ana dil şıklar öğrenilen dil";
      }
      else
      return "Boşluk doldurma";
  }
  
  detail(data:any){
   
  }
  delete(data:any){

  }

}
